import { render, staticRenderFns } from "./blok-text.vue?vue&type=template&id=2c0d8b11&scoped=true"
import script from "./blok-text.vue?vue&type=script&lang=js"
export * from "./blok-text.vue?vue&type=script&lang=js"
import style0 from "./blok-text.vue?vue&type=style&index=0&id=2c0d8b11&prod&lang=scss&scoped=true"
import style1 from "./blok-text.vue?vue&type=style&index=1&id=2c0d8b11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d8b11",
  null
  
)

export default component.exports